<template>
    <div>
        <div class="contentElement__imageWrapper -one">
            <div
                v-for="image in allImages"
                :key="image.id"
            >
                <transition
                    name="fade"
                    mode="in-out"
                >
                    <img
                        v-if="image.url === firstImage.url"
                        :src="image.url"
                        :alt="image.alt"
                        class="contentElement__image"
                    >
                </transition>
            </div>
        </div>
        <div class="contentElement__imageWrapper -two">
            <div
                v-for="image in allImages"
                :key="image.id"
            >
                <transition
                    name="fade"
                    mode="in-out"
                >
                    <img
                        v-if="image.url === secondImage.url"
                        :src="image.url"
                        :alt="image.alt"
                        class="contentElement__image"
                    >
                </transition>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {

    props: {
        images: {
            type: Array,
            required: true,
        },
    },

    computed: {
        ...mapGetters(['allImages']),

        firstImage () {
            return this.images[0]
        },

        secondImage () {
            return this.images[1]
        },
    },

}
</script>
